<template>
    <div>
        <div class="main-article">
            <div class="article">
                <p class="sub-title">北京版权调解中心</p>
                <p class="paragraph">北京版权调解中心作为首都版权协会的内设机构，是北京市版权局主管的专业调解组织。主要受理案件类型包括：版权行政管理部门指定的著作权行政调解案件； 司法机关委托的著作权司法调解案件；权利人（或当事人）直接提出申请的行业调解案件。涉及出版物、影视、音乐、计算机软件、图片、美术作品等各个著作权相关领域。 </p>
                <p class="paragraph">北京版权调解中心是最高人民法院认可的知识产权专业调解机构、北京市高院特邀知识产权调解机构；协会下属的首都版权协会知识产权纠纷人民调解委员会是 北京市司法局认可的知识产权调解行专组织。同时，调解中心调解员派驻北京知识产权法院、北京互联网法院、朝阳区法院知识产权庭协助进行知识产权司法调解工作。北京版权调解中心 自成立以来，案件受理量连年呈稳步上升趋势，从2012年受理案件十几起，到2019年年受理案件量达6000余起。 </p>
                <p class="paragraph">2020年3月，在北京市版权局的指导下，北京互联网法院的支持下，北京版权线上调解平台正式上线运营。这是脱胎于北京市司法调解平台的专业调解平台，也是全 国首个在政府指导下的行业调解平台。 </p>
                <p class="paragraph">北京版权调解平台上线以来，极大的方便了当事人远程调解的需求。线上调解平台的启用，不但是疫情期间助推企业健康发展、维护当事人合法权益的便民服务举措 ，也将是北京市版权保护工作迈入新高度的标志。</p>
            </div>
            <div class="article-picture">
                <div style="width: 484px;height: 533px;margin-top: 60px;">
                    <img :src="article31" width="100%"/>
                </div>
            </div>
        </div>
        <div class="time-axis">
            <ul>
                <li>
                    <p class="title">2012-至今</p>
                    <p class="des">上线时间</p>
                </li>
                <li>
                    <p class="title">著作权领域</p>
                    <p class="des">受理范围</p>
                </li>
                <li>
                    <p class="title">2020.03</p>
                    <p class="des">正式运营</p>
                </li>
                <li>
                    <p class="title">10484余起</p>
                    <p class="des">受理案件</p>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import article31 from '@/assets/images/v2/article/article3-1.png';
    export default{
        name:"article1",
        data(){
            return{
                article31
            }
        }
    }
</script>
<style lang="less" scoped>
    .main-article{
      width: 1200px;
      margin: 0 auto;
      display: flex;
      .article{
        flex: 1;
        .sub-title{
            font-family: Source Han Sans CN;
            font-size: 24px;
            font-weight: 700;
            line-height: 36px;
            text-align: left;
            color: #666;
            padding: 90px 30px 30px
        }
        .paragraph{
            color: #999;
            font-family: Source Han Sans CN;
            font-size: 14px;
            font-weight: 700;
            line-height: 30px;
            text-align: left;
            text-indent: 28px;
            width: 608px;
            // padding: 0 20px;
        }
      }
    }
      
     .time-axis{
        color: #fff;
        // margin: 0.5rem 0;
        width: 1200px;
        margin:  0 auto;
        padding: 50px 0;
        ul{
            display: flex;
            background-color: #F8F8F8;
            box-shadow: 0px 0px 12px 0px #0000001A;
        }
        ul li{
            width: 283px;
            height: 200px;
            text-align: center;
            justify-content: center;
            display: flex;
            flex-direction: column;
            position: relative;
            .title{
                font-family: Source Han Sans CN;
                font-size: 38px;
                font-weight: 600;
                line-height: 57px;
                text-align: justified;
                padding: 10pxm 0;
                color: #666;
            }
            .des{
                font-family: Source Han Sans CN;
                font-size: 14px;
                font-weight: 600;
                line-height: 21px;
                text-align: justified;
                color: #999;
            }
        }
        ul li:nth-child(n + 2)::after{
            content: "";
            position: absolute;
            left: 0;
            width: 1px;
            height: 57px;
            background-color: #EFEFEF;
        
        }
    }
</style>